'use strict';

/**
 * Delete all undefined values from an object or array.
 *
 * @deprecated This function serves no purpose, and isn't type-safe.
 *
 * @template T - The type of the object or array.
 * @param {T} x - The object or array from which to delete undefined values.
 * @param {boolean} [recursive=true] - Whether to delete undefined values recursively.
 * @returns {T | null} - A new object or array with undefined values removed.
 */ function deleteUndefined(x, recursive = true) {
    if (!x) return x != null ? x : null;
    if (Array.isArray(x)) {
        if (recursive) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return x.map((v)=>deleteUndefined(v));
        }
    } else {
        Object.keys(x).forEach((k)=>{
            if (x[k] === undefined) {
                delete x[k];
            } else if (recursive && x[k] && [
                'object',
                'array'
            ].includes(typeof x[k])) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                x[k] = deleteUndefined(x[k]);
            }
        });
    }
    Object.keys(x).forEach((k)=>{
        if (x[k] === undefined) {
            delete x[k];
        }
    });
    return x;
}

module.exports = deleteUndefined;
